export default __webpack_public_path__ + "static/media/05_01.38f0ed30.jpg";